var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#455A64;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#78909C;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#ECEFF1;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFCA28;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#B0BEC5;}\n\t.st7{fill:#37474F;}\n\t.st8{fill:#455A64;}\n\t.st9{fill:#9CCC65;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#C5E1A5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#26C6DA;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:#EF5350;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:#B0BEC5;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#EF9A9A;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#FFE082;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:#D32F2F;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:#0097A7;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#689F38;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st19{fill:#FFA000;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:#FFA000;}\n\t.st21{fill:#FF6F00;}\n\t.st22{fill:#D32F2F;}\n\t.st23{fill:#0097A7;}\n\t.st24{fill:none;stroke:#80DEEA;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st25{fill:#689F38;}\n\t.st26{fill:none;stroke:#B0BEC5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{fill:#78909C;stroke:#37474F;stroke-miterlimit:10;}\n\t.st28{fill:#78909C;}\n\t.st29{fill:#B71C1C;}\n\t.st30{fill:#F57F17;}\n\t.st31{fill:#006064;}\n\t.st32{fill:#26A69A;stroke:#37474F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M46.7,4.6c-5,0.7-9.1,4.6-10,9.6c-0.7,4,0.5,7.6,2.9,10.3h-3.1v3c0,0.6,0.4,1,1,1l10.7,0 c6.4,0,11.9-4.8,12.3-11.2C61,9.7,54.4,3.5,46.7,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M29.5,39.5h-16c-5.5,0-10,4.5-10,10V61c0,1.4,1.1,2.5,2.5,2.5h31c1.4,0,2.5-1.1,2.5-2.5V49.5 C39.5,44,35,39.5,29.5,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M29.5,35.5h-16c-5.5,0-10,4.5-10,10V57c0,1.4,1.1,2.5,2.5,2.5h31c1.4,0,2.5-1.1,2.5-2.5V45.5 C39.5,40,35,35.5,29.5,35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M5.5,45.5c0-4.4,3.6-8,8-8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11.5,
    y1: 59.5,
    x2: 11.5,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 31.5,
    y1: 59.5,
    x2: 31.5,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 21.5,
    cy: 23.5,
    r: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 26.1,
    y1: 28.1,
    x2: 16.9,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.3,16.6L9.8,20.8c1.2-5.3,6-9.3,11.7-9.3C25.6,11.5,29.1,13.5,31.3,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.3,14.4L29.3,14.4c2.5,2.2,4.2,5.4,4.2,9.1h0c-2.3,0-4.2-1.9-4.2-4.2V14.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "27.6,45.5 21.6,41.5 15.6,45.5 15.6,35.5 27.6,35.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "21.6,41.5 15.6,35.5 27.6,35.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.5,0.5c-6.6,0-12,5.4-12,12c0,3.5,1.5,6.6,3.9,8.8l-3.9,3.2h12c6.6,0,12-5.4,12-12S55.1,0.5,48.5,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M38.5,12.5c0-5.5,4.5-10,10-10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,14.5L48.5,14.5c-0.8,0-1.5-0.7-1.5-1.5V7c0-0.8,0.7-1.5,1.5-1.5h0C49.3,5.5,50,6.2,50,7v6 C50,13.8,49.3,14.5,48.5,14.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 48.5,
    cy: 18,
    r: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/S2.be6c1049b4d56a26a83373a249a4afee.svg";
export { ForwardRef as ReactComponent };